module.exports = __webpack_public_path__ + "231d8cf670729881585614d3322790d6.svg";